import * as React from 'react';
import {FC} from 'react';
import {Create, CreateProps, SimpleForm, TextInput, TranslatableInputs } from 'react-admin';
import cfgLocales from '../../config/locale';
import Title from "../../components/list/Title";
import {filterProps} from "../../functions/common";
import {listEditCreate} from "../../styles/listEditCreate";

const ModalCreate: FC<CreateProps> = props => {
    const newProps = filterProps(props);
    const classes = listEditCreate();

    return (
        <Create {...newProps}>
            <SimpleForm className={classes.sidebar}>
                <Title label="resources.admin/modals.create" />
                <TranslatableInputs locales={Object.keys(cfgLocales.languageOptions)} defaultLocale={cfgLocales.defaultLocale}>
                    <TextInput autoFocus source="title" fullWidth />
                </TranslatableInputs>
            </SimpleForm>
        </Create>
    );
};
export default ModalCreate;
